/**
 * 设备备注。
 *
 * 加入冰箱时随手记一笔，用途只有一个：设置页的"谁在用"列表里得能认出
 * 哪台是哪台。只显示"设备 1 / 设备 2"的话，手机丢了都不知道该踢哪一个。
 *
 * 刻意不做设备指纹：那是隐私上不划算的东西 —— 为了一个标注功能去采集
 * 硬件特征，代价远大于收益。用户觉得不对可以自己改名字。
 */

export function deviceLabel(): string {
  if (typeof navigator === 'undefined') return '';

  const ua = navigator.userAgent;
  const platform = /iPhone|iPad|iPod/.test(ua)
    ? 'iPhone'
    : /Android/.test(ua)
      ? 'Android'
      : /Macintosh/.test(ua)
        ? 'Mac'
        : /Windows/.test(ua)
          ? 'Windows'
          : '浏览器';

  /**
   * 浏览器判定必须从"最特殊的"往"最通用的"排。
   * iOS 上的第三方浏览器各有自己的标记（CriOS / FxiOS / EdgiOS），
   * 而它们都同时带 Safari 标记 —— 先判 Safari 的话全都成了 Safari。
   */
  const browser = /\bEdg[A-Z]?\//.test(ua)
    ? 'Edge'
    : /\b(Chrome|CriOS)\//.test(ua)
      ? 'Chrome'
      : /\b(Firefox|FxiOS)\//.test(ua)
        ? 'Firefox'
        : /\bSafari\//.test(ua)
          ? 'Safari'
          : '';

  return [platform, browser].filter(Boolean).join(' · ').slice(0, 40);
}
